import config, { loadAppConfig } from "src/config/appConfig"

// The runtime configuration must be in place before any module that reads it is evaluated,
// so the real entry point is imported dynamically. A static import would be hoisted and
// src/auth/oidc.ts would build its UserManager against an empty configuration.
loadAppConfig()
  .then(() => {
    const faro = config.faro
    if (!faro) return
    // Its own chunk, after the configuration: the order system's origin is read from it.
    return import("src/otel/faro").then(({ startFaro }) => startFaro(faro, [config.api.orderSystemBaseUrl]))
  })
  .then(() => import("src/bootstrap"))
  .catch((error) => {
    // Nothing is mounted yet, so report the failure without React.
    // eslint-disable-next-line no-console
    console.error("Application startup failed", error)
    const root = document.getElementById("root")
    if (root) {
      root.textContent = "Die Anwendung konnte nicht geladen werden. Bitte laden Sie die Seite neu."
    }
  })
